var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var PackageReportsPerPackage = /** @class */ (function (_super) {
    __extends(PackageReportsPerPackage, _super);
    function PackageReportsPerPackage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageReportsPerPackage.prototype.getPackageName = function () {
        return this.package_name;
    };
    PackageReportsPerPackage.prototype.getPackageId = function () {
        return Number(this.package_id);
    };
    PackageReportsPerPackage.prototype.getTotalPatients = function () {
        return Number(this.total_patients);
    };
    PackageReportsPerPackage.prototype.getTotalTransactions = function () {
        return this.roundNumber(this.total_transactions);
    };
    PackageReportsPerPackage.prototype.getTotalPackageReservations = function () {
        return Number(this.total_package_reservations);
    };
    return PackageReportsPerPackage;
}(Model));
export default PackageReportsPerPackage;
